import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { lockClick } from 'directives/cs-capture-cover/cs-capture-cover.directive';
import { LL } from 'i18n/i18n.service';
import { untranslatedString } from 'models/translated-string';
import { CsPage, NavController } from 'providers/nav-controller';
import { ModalPageMarker } from 'providers/modal-page-marker';
import { AuthService } from 'services/auth.service';
import { CloudFunctionsService } from 'services/cloud-functions.service';
import { AlertController, AlertButtonRole } from 'providers/alert-controller';
import { MenuController } from 'providers/menu-controller';
import { AccessCodeActivationService } from 'services/access-code-activation';

@Component({
    selector: 'page-redeem-code',
    templateUrl: 'redeem-code.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ModalPageMarker]
})
export class RedeemCodePage extends CsPage<{}> {
  protected LL = LL;
  protected email: string;
  protected key = '';
  protected message = '';

  constructor(
    public navCtrl: NavController,
    protected auth: AuthService,
    protected cloudFunctions: CloudFunctionsService,
    protected alertCtrl: AlertController,
    private menuCtrl: MenuController,
    private cdRef: ChangeDetectorRef,
    private accessCodeActivation: AccessCodeActivationService,
  ) {
    super();
  }

  async ionViewCanEnter() {
    this.email = this.auth.user.email;
    this.cdRef.markForCheck();
  }

  async ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }

  async ionViewWillLeave() {
    this.menuCtrl.enable(true);
  }

  onCancelButtonClick(event: Event) {
    lockClick(event, this.navCtrl.popAsync());
  }

  handleRedeem() {
    void this.redeemCodeAsync();
  }
  async redeemCodeAsync() {
    // the shared flow shows the loading overlay, re-logs in and, on success, the confirmation and the move away
    const code = this.key;
    const error = await this.accessCodeActivation.activateAsync(async () => (await this.cloudFunctions.useActivationKeyAsync({ code })).error ?? '');

    this.cdRef.markForCheck();
    if (error) {
      this.message = error;
      await this.alertCtrl.showAlertAsync({
        message: untranslatedString(error),
        enableBackdropDismiss: true,
        buttons: [
          {
            text: LL.common.buttons.ok(),
            role: AlertButtonRole.Primary,
          },
        ],
      });
      console.log(this.message);
    }
  }
}
